export default __webpack_public_path__ + "static/media/happy_home-1.3aeb9500.jpg";